// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir=ltr] .infoIcon--RsoXW {
  margin-left: 5px;
}[dir=rtl] .infoIcon--RsoXW {
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SingleTrend/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB,CAFA;EACE,iBAAgB;AAClB","sourcesContent":[".infoIcon {\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoIcon": `infoIcon--RsoXW`
};
export default ___CSS_LOADER_EXPORT___;
